import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  revisionService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'revService',
    'revisionHistoryModel',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      Revision,
      RevisionHistory
    ) {
      'use strict';

      var loadRevisionsDeferred = null;

      function handleError(err, status) {
        //falhou
        if (status === 404 || status === -1) {
          var error = {
            status_code: status,
            error: $filter('translate')('SERVER OFFLINE'),
            error_description: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
          return error;
        }

        if (status === 403) {
          var ex1 = {
            status_code: status,
            error: $filter('translate')('REVISION NOT PUBLIC'),
            error_description: $filter('translate')(
              'REVISION NOT PUBLIC DESCRIPTION'
            ),
          };
          return ex1;
        }

        if (status !== 400) {
          var ex = {
            status_code: status,
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function cancelLoadRevisions() {
        if (loadRevisionsDeferred !== null) {
          loadRevisionsDeferred.resolve({
            result: [],
            count: 0,
          });

          loadRevisionsDeferred = null;
        }
      }

      function loadRevisionsNew(idFolder) {
        loadRevisionsDeferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'revisions/folder/' +
              idFolder +
              '/all',
            {
              timeout: loadRevisionsDeferred.promise,
            }
          )
          .then((res) => {
            var result = [];
            var data = resolveReferences(res.data);

            if (data.length > 0) {
              data.forEach(function (d) {
                var rev = new Revision(d, null);
                result.push(rev);
              });
            }

            if (loadRevisionsDeferred !== null) {
              loadRevisionsDeferred.resolve(result);
              loadRevisionsDeferred = null;
            }
          })
          .catch((err) => {
            if (err.status === -1) return;

            var error = handleError(err.data, err.status);

            if (loadRevisionsDeferred !== null) {
              loadRevisionsDeferred.reject(error);
              loadRevisionsDeferred = null;
            }
          });

        return loadRevisionsDeferred.promise;
      }

      function loadRevisionsFavorites(page, pageSize) {
        loadRevisionsDeferred = $q.defer();

        $http.post(
          webApiSettings.apiServiceBaseUri + 'revisions/favorites',
          {
            Page: page,
            PageSize: pageSize,
          },
          {
            timeout: loadRevisionsDeferred.promise,
          }
        )
        .then((res) => {
          const total = res.data.Count || 0;

          const data = resolveReferences(res.data.Result || []);
          const items = data.map(r => new Revision(r, null));

          loadRevisionsDeferred.resolve({
            total: total,
            items: items
          });

          loadRevisionsDeferred = null;
        })
        .catch((err) => {
          if (err.status === -1) return;

          const error = handleError(err.data, err.status);

          if (loadRevisionsDeferred) {
            loadRevisionsDeferred.reject(error);
            loadRevisionsDeferred = null;
          }
        });

        return loadRevisionsDeferred.promise;
      }

      function loadRevisionsPublicLinks() {
        loadRevisionsDeferred = $q.defer();

        $http
          .get(webApiSettings.apiServiceBaseUri + 'revisions/publicLinks', {
            timeout: loadRevisionsDeferred.promise,
          })
          .then(
            function (res) {
              var result = [];
              var data = resolveReferences(res.data);

              if (res.data.length > 0) {
                data.forEach(function (d) {
                  var rev = new Revision(d, null);
                  result.push(rev);
                });
              }

              if (loadRevisionsDeferred !== null) {
                loadRevisionsDeferred.resolve(result);
                loadRevisionsDeferred = null;
              }
            },
            function (err) {
              if (err.status === -1) {
                return;
              }

              var error = handleError(err.data, err.status);

              if (loadRevisionsDeferred !== null) {
                loadRevisionsDeferred.reject(error);
                loadRevisionsDeferred = null;
              }
            }
          );

        return loadRevisionsDeferred.promise;
      }

      function loadRevisionsCheckouts(page, pageSize) {
        loadRevisionsDeferred = $q.defer();

        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'revisions/checkouts',
            {
              Page: page,
              PageSize: pageSize,
            },
            {
              timeout: loadRevisionsDeferred.promise,
            }
          )
          .then(
            function (res) {
              var result = [];
              var data = resolveReferences(res.data).Result;

              if (data.length > 0) {
                data.forEach(function (d) {
                  var rev = new Revision(d, null);
                  result.push(rev);
                });
              }

              if (loadRevisionsDeferred !== null) {
                loadRevisionsDeferred.resolve(result);
                loadRevisionsDeferred = null;
              }
            },
            function (err) {
              if (err.status === -1) {
                return;
              }

              var error = handleError(err.data, err.status);

              if (loadRevisionsDeferred !== null) {
                loadRevisionsDeferred.reject(error);
                loadRevisionsDeferred = null;
              }
            }
          );

        return loadRevisionsDeferred.promise;
      }

      function loadRevisionsMyActivityExpired(filter) {
        loadRevisionsDeferred = $q.defer();

        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}revisions/myActivityExpired`,
            filter,
            {
              timeout: loadRevisionsDeferred.promise,
            }
          )
          .then((res) => {
            var result = [];
            var data = resolveReferences(res.data).ResultAct;
            if (res.data.ResultAct.length > 0) {
              data.forEach(function (d) {
                result.push(d);
              });
            }

            if (loadRevisionsDeferred !== null) {
              loadRevisionsDeferred.resolve(result);
              loadRevisionsDeferred = null;
            }
          })
          .catch((err) => {
            if (err.status === -1) {
              return;
            }

            var error = handleError(err.data, err.status);

            if (loadRevisionsDeferred !== null) {
              loadRevisionsDeferred.reject(error);
              loadRevisionsDeferred = null;
            }
          });

        return loadRevisionsDeferred.promise;
      }

      function loadRevisionsMyDocsExpired(filter) {
        loadRevisionsDeferred = $q.defer();

        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}revisions/myDocsExpired`,
            filter,
            {
              timeout: loadRevisionsDeferred.promise,
            }
          )
          .then((res) => {
            var result = [];
            var data = resolveReferences(res.data).Result;

            if (res.data.Result.length > 0) {
              data.forEach(function (d) {
                var rev = new Revision(d, null);
                result.push(rev);
              });
            }

            if (loadRevisionsDeferred !== null) {
              loadRevisionsDeferred.resolve(result);
              loadRevisionsDeferred = null;
            }
          })
          .catch((err) => {
            if (err.status === -1) {
              return;
            }

            var error = handleError(err.data, err.status);

            if (loadRevisionsDeferred !== null) {
              loadRevisionsDeferred.reject(error);
              loadRevisionsDeferred = null;
            }
          });

        return loadRevisionsDeferred.promise;
      }

      function loadRevisionsShareds(page, pageSize) {
        loadRevisionsDeferred = $q.defer();

        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}revisions/shareds`,
            {
              Page: page,
              PageSize: pageSize,
            },
            {
              timeout: loadRevisionsDeferred.promise,
            }
          )
          .then((res) => {
            var result = [];
            var data = resolveReferences(res.data);

            if (res.data.length > 0) {
              data.forEach(function (d) {
                var rev = new Revision(d, null);
                result.push(rev);
              });
            }

            if (loadRevisionsDeferred !== null) {
              loadRevisionsDeferred.resolve(result);
              loadRevisionsDeferred = null;
            }
          })
          .catch((err) => {
            if (err.status === -1) {
              return;
            }

            var error = handleError(err.data, err.status);

            if (loadRevisionsDeferred !== null) {
              loadRevisionsDeferred.reject(error);
              loadRevisionsDeferred = null;
            }
          });

        return loadRevisionsDeferred.promise;
      }

      function loadRevisionsTrashcan(page, pageSize) {
        loadRevisionsDeferred = $q.defer();

        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'revisions/trashcan',
            {
              Page: page,
              PageSize: pageSize,
            },
            {
              timeout: loadRevisionsDeferred.promise,
            }
          )
          .then((res) => {
            var result = [];
            var data = resolveReferences(res.data.Result);

            if (res.data.Result.length > 0) {
              data.forEach(function (d) {
                var rev = new Revision(d, null);
                result.push(rev);
              });
            }

            if (loadRevisionsDeferred !== null) {
              loadRevisionsDeferred.resolve({
                items: result,
                count: res.data.Count
              });
              loadRevisionsDeferred = null;
            }
          })
          .catch((err) => {
            if (err.status === -1) return;
            var error = handleError(err.data, err.status);

            if (loadRevisionsDeferred !== null) {
              loadRevisionsDeferred.reject(error);
              loadRevisionsDeferred = null;
            }
          });

        return loadRevisionsDeferred.promise;
      }

      function loadOldRevisions(id) {
        var deferred = $q.defer();

        $http
          .get(webApiSettings.apiServiceBaseUri + 'revisions/old/' + id)
          .then((result) => {
            var data = resolveReferences(result.data);
            var hist = [];
            for (var cont = 0, len = data.length; cont < len; cont++) {
              hist.push(new RevisionHistory(data[cont]));
            }
            deferred.resolve(hist);
          })
          .catch((err) => deferred.reject(handleError(err)));

        return deferred.promise;
      }

      function findRevision(id, isWorkflow, isOldRevision) {
        var deferred = $q.defer();

        var url = 'revisions/' + id + (isOldRevision ? '/old' : '');
        if (isWorkflow) url = 'revisions/workflow/' + id;

        $http
          .get(webApiSettings.apiServiceBaseUri + url)
          .then((result) => {
            var data = result.data;
            if (!isOldRevision) {
              deferred.resolve(new Revision(data));
            } else {
              deferred.resolve(new RevisionHistory(data));
            }
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function findRevisionGuid(guid, workflow) {
        var deferred = $q.defer();
        var url =
          webApiSettings.apiServiceBaseUri + 'revisions/publicRevision/' + guid;

        if (workflow)
          url = webApiSettings.apiServiceBaseUri + 'workflows/revision/' + guid;

        $http
          .get(url)
          .then((result) => {
            var data = result.data;
            deferred.resolve(new Revision(data));
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function officeViewLink(id) {
        var url =
          webApiSettings.viewerBaseUri + '#/' + 'public/view/' + id.guid;

        window.open(url, '_self');

        return null;
      }

      function imageViewLink(id, isPublic, isWorkflow, isOldRevision) {
        var deferred = $q.defer();
        loadRevisionsDeferred = deferred;

        var webApiMethod = 'revisions/file/generate/';

        if (isPublic) webApiMethod = 'revisions/file/public/generate/';

        if (isWorkflow) webApiMethod = 'revisions/file/workflow/generate/';

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              webApiMethod +
              id +
              (isOldRevision ? '/old' : '') +
              '?browserView=1',
            {
              responseType: 'image/tiff',
            }
          )
          .then((result) => {
            var url = result.data;
            if (Array.isArray(url)) {
              var links = [];

              url.forEach(function (u) {
                links.push(
                  webApiSettings.apiServiceBaseUri + 'revisions/file/hash/' + u
                );
              });

              deferred.resolve(links);
            } else {
              deferred.resolve(
                webApiSettings.apiServiceBaseUri + 'revisions/file/hash/' + url
              );
            }
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);

            deferred.reject(error);
            loadRevisionsDeferred = null;
          });

        return deferred.promise;
      }

      function getPublicLinkActive(documentType) {
        var deferred = $q.defer();

        var url =
          webApiSettings.apiServiceBaseUri + 'dashboard/getPublicLinkActive/';
        if (documentType !== 0) url += `?documentTypeId=${documentType.Id}`;

        $http
          .get(url)
          .then((response) => {
            var result = resolveReferences(response.data);
            deferred.resolve(result);
          })
          .catch((err) => {
            deferred.reject(handleError(err.data, err.status));
          });

        return deferred.promise;
      }

      function getSharedFolder(isExpired) {
        var deferred = $q.defer();

        var url =
          webApiSettings.apiServiceBaseUri +
          `dashboard/getSharedFolder/?isExpired=${isExpired}`;

        $http
          .get(url)
          .then((response) => {
            var result = resolveReferences(response.data);
            deferred.resolve(result);
          })
          .catch((err) => {
            deferred.reject(handleError(err.data, err.status));
          });

        return deferred.promise;
      }

      function getExpiredRevisions(documentType, startDate, endDate, author) {
        var deferred = $q.defer();

        var url =
          webApiSettings.apiServiceBaseUri + 'dashboard/getExpiredRevisions';
        // if (startDate && endDate && documentType) url += `?start=${startDate}&end=${endDate}&documentTypeId=${documentType.Id}`
        // else if (startDate && documentType) url += `?start=${startDate}&documentTypeId=${documentType.Id}`
        // else if (endDate && documentType) url += `?end=${endDate}&documentTypeId=${documentType.Id}`
        // else if (startDate && endDate) url += `?start=${startDate}&end=${endDate}`
        // else if (startDate) url += `?start=${startDate}`
        // else if (endDate) url += `?end=${endDate}`
        // else if (documentType) url += `?documentTypeId=${documentType.Id}`

        $http
          .get(url, {
            params: {
              startAt: startDate,
              endAt: endDate,
              documentTypeId: documentType.Id,
              authorId: author.Id,
            },
          })
          .then((response) => {
            var result = resolveReferences(response.data);
            deferred.resolve(result);
          })
          .catch((err) => {
            deferred.reject(handleError(err.data, err.status));
          });

        return deferred.promise;
      }

      function convertToPdf(revisionId) {
        var deferred = $q.defer();

        var url =
          webApiSettings.apiServiceBaseUri + 'revisions/convertToPdf';

        $http
          .post(url, revisionId)
          .then((response) => {
            var result = resolveReferences(response.data);
            deferred.resolve(result);
          })
          .catch((err) => {
            deferred.reject(handleError(err.data, err.status));
          });

        return deferred.promise;
      }

      function emptyRevisionsTrashcan() {
        var deferred = $q.defer();

        $http
          .delete(webApiSettings.apiServiceBaseUri + 'revisions/trashcan/empty')
          .then((response) => {
            var result = resolveReferences(response.data);
            deferred.resolve(result);
          })
          .catch((err) => {
            deferred.reject(handleError(err.data, err.status));
          });

        return deferred.promise;
      }

      function loadRevisionsPaged(idFolder, page, pageSize) {
        return $http.post(
          webApiSettings.apiServiceBaseUri +
            'revisions/folder/' + idFolder + '/paged',
          {
            page: page,
            pageSize: pageSize
          }
        ).then((res) => {

          var data = res.data || {};

          var items = data.items || data.Items || [];

          return {
            total: data.total || data.Total || 0,
            items: items.map(d => new Revision(d, null))
          };
        });
      }

      function run() {
        try {
          var revisionServiceFactory = {};

          revisionServiceFactory.getExpiredRevisions = logWrapper(
            getExpiredRevisions,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.getPublicLinkActive = logWrapper(
            getPublicLinkActive,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.getSharedFolder = logWrapper(
            getSharedFolder,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.officeViewLink = logWrapper(
            officeViewLink,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.imageViewLink = logWrapper(
            imageViewLink,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.findRevision = logWrapper(
            findRevision,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.findRevisionGuid = logWrapper(
            findRevisionGuid,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.cancelLoadRevisions = logWrapper(
            cancelLoadRevisions,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.loadRevisionsNew = logWrapper(
            loadRevisionsNew,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.loadRevisionsFavorites = logWrapper(
            loadRevisionsFavorites,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.loadRevisionsPublicLinks = logWrapper(
            loadRevisionsPublicLinks,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.loadRevisionsCheckouts = logWrapper(
            loadRevisionsCheckouts,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.loadRevisionsShareds = logWrapper(
            loadRevisionsShareds,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.loadRevisionsMyActivityExpired = logWrapper(
            loadRevisionsMyActivityExpired,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.loadRevisionsMyDocsExpired = logWrapper(
            loadRevisionsMyDocsExpired,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.loadRevisionsTrashcan = logWrapper(
            loadRevisionsTrashcan,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.loadOldRevisions = logWrapper(
            loadOldRevisions,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.convertToPdf = logWrapper(
            convertToPdf,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.emptyRevisionsTrashcan = logWrapper(
            emptyRevisionsTrashcan,
            runtimeConstant.isDebugServicesInternals
          );
          revisionServiceFactory.loadRevisionsPaged = logWrapper(
            loadRevisionsPaged,
            runtimeConstant.isDebugServicesInternals
          );

          return revisionServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
